import { nanoid } from 'nanoid'

import type { NewId } from './types'

/** Hidden id generator for new entities/tracks/links (injected into the pure model). */
export const newId: NewId = () => nanoid()
